import type { FragmentOf, Timeframe } from "@opensea/graphql"
import { graphql, readFragment } from "@opensea/graphql"
import { ChangeAnimation } from "@opensea/ui-kit"
import { Volume } from "@/components/price/Volume"
import { StatsVolumeFragment, useStatsVolume } from "./useStatsVolume"

export const StatsTableRowVolumeFragment = graphql(
  `
    fragment StatsTableRowVolume on Collection {
      ...StatsVolume
    }
  `,
  [StatsVolumeFragment],
)

type Props = {
  className?: string
  collection: FragmentOf<typeof StatsTableRowVolumeFragment>
  timeframe: Timeframe
}

export function StatsTableRowVolume({
  collection: collectionKey,
  timeframe,
}: Props) {
  const collection = readFragment(StatsTableRowVolumeFragment, collectionKey)
  const getStatsVolume = useStatsVolume()

  const volume = getStatsVolume({ collection, timeframe })

  return (
    <ChangeAnimation display="compact" value={volume.native.unit}>
      <span>
        <Volume volume={volume} />
      </span>
    </ChangeAnimation>
  )
}
